import {Component} from "react";
import Glob from "../../libs/Glob.mjs";
import CloseIcon from "../../media/images/CloseIcon.mjs";
import appLib from "../../libs/appLib.mjs";

const prefix="PeriGraphicNodeInfo";

const NodeInfoLine = class extends Component {
	render() {
		if ( ! this.props.label || ! this.props.value ) return null;
		return (
			<div className={"line"} key={this.props.key}>
				<span>{ this.props.label}</span>
				<div>{ this.props.value }</div>
			</div>
		)
	}
}

const PeriGraphicNodeInfo = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			x: 10 + 20 * (props.index || 0),
			y: 10 + 35 * (props.index || 0)
		};
		this.uid = Glob.generateUid(prefix);
		this.values = this.values.bind(this);
		this.status = this.status.bind(this);
		this.moreValues = this.moreValues.bind(this);
	}
	values() {
		return(
			<>
				{  this.status() }
				<NodeInfoLine label={"ID"} value={this.props.node.id} />
				<NodeInfoLine label={"Type"} value={this.props.node.type} />
				<NodeInfoLine label={"Subtype"} value={this.props.node.nodeType} />
				<NodeInfoLine label={"Name"} value={this.props.node.name} />
				{ this.moreValues() }
			</>
		)
	}
	status() {
		if ( ! this.props.node.status || typeof this.props.node.status !== 'object') return null;
		let v = [];
		const keys = Object.keys(this.props.node.status);
		['c','i','a','o'].filter( k => keys.includes(k)).forEach(k => {
			v.push( <div key={k}><em>{ k }</em><strong>{ parseInt(this.props.node.status[k] * 100)}</strong></div> );
		});
		if ( ! v.length ) return null;
		return <NodeInfoLine label={"⚠️"} value={v} />;
	}
	moreValues() {
		return null;
	}
	render() {
		return (
			<div
				id={ this.uid }
				className={prefix}
				style={{top: `${ this.state.y }px`,left: `${ this.state.x }px`}}
				onMouseDown={ ()=>{
					const me = window.document.getElementById(this.uid);
					me.parentNode.querySelectorAll('div.'+prefix).forEach( n => {
						n.style.removeProperty('z-index');
					});
					me.style.zIndex = 20;
				}}
				onDoubleClick={ ()=>{
					const me = window.document.getElementById(this.uid);
					me.style.removeProperty('width');
					me.style.removeProperty('height');
				}}
				onContextMenu={ e => {
					e.preventDefault();
					e.stopPropagation();
					this.props.select();
				}}
			>
				<div className={"title"}>
					<div
						onMouseDown={ e=>{
							const element = window.document.getElementById(this.uid);
							appLib.dragging(element, e.clientX - element.offsetLeft, e.clientY - element.offsetTop);
						}}
						onMouseUp={ () =>{
							const element = window.document.getElementById(this.uid);
							this.setState({
								x: element.offsetLeft,
								y: element.offsetTop
							}, ()=>{
								appLib.dragging(false);
							})
						}}
						title={ this.props.node.name }
					>
						{ this.props.node.name }
					</div>
					<span onClick={ this.props.close }>
						<CloseIcon />
					</span>
				</div>
				<div className={"body"}>
					{ this.values() }
				</div>
			</div>
		)
	}
}

export default PeriGraphicNodeInfo;